import React from "react";
import classNames from "classnames";
import { HeaderSearch } from "Components/Layout";
import { Find } from "Components/Icons";
import { DesignContextProvider } from "Components/DesignContext";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";

import classes from "./WorkplaceSearchForm.module.scss"

const WorkplaceSearchForm: React.FC = () => {   
   const placeholder = "Find workspace nearby";

   return (
      <DesignContextProvider name="marketing" >
         <HeaderSearch
            className={classNames("header-search", classes.searchForm)}
            onButtonClick={() => undefined}
            ariaLabel={placeholder}
            placeholder={placeholder}
            buttonContent={() => <Find />}
         />
      </DesignContextProvider>
   );
};

export default WorkplaceSearchForm